import React, { useState, useEffect, Suspense } from 'react';

interface DynamicComponentRendererProps {
  contentType: string;
  slug: string;
}

const DynamicComponentRenderer: React.FC<DynamicComponentRendererProps> = ({ contentType, slug }) => {
  const [Component, setComponent] = useState<React.ComponentType | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadComponent = async () => {
      try {
        setLoading(true);
        setError(null);
        const componentModule = await import(`../content/${contentType}/${slug}.jsx`);
        setComponent(() => componentModule.default);
      } catch (err) {
        console.error('Failed to load component:', err);
        setError('Failed to load component');
      } finally {
        setLoading(false);
      }
    };

    loadComponent();
  }, [contentType, slug]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!Component) {
    return <div>Component not found</div>;
  }

  return <Component />;
};

export default DynamicComponentRenderer;